import {Component, EventEmitter, OnInit, OnDestroy, Output, TemplateRef, ViewChild} from '@angular/core';

import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap';
import {TreeNode} from 'primeng/api';

import {EquipmentService} from '../../../core/services/equipment.service';
import {TranslateService} from '@ngx-translate/core';
import {AlertService} from '../../../core/services/alert.service';
import {MessageData} from '../../../core/models/message-data';
import {HttpErrorResponse} from '@angular/common/http';
import {INgxMyDpOptions} from 'ngx-mydatepicker';
import {EquipmentGroup} from '../../models/equipment-group';
import {Subscription} from 'rxjs/Subscription';
import {OfferEntryDataService} from '../../../core/services/offer-entry-data.service';
import {MessageService} from '../../../core/services/message.service';
import {UtilsService} from '../../../core/services/utils.service';


@Component({
    selector: 'app-manage-group',
    templateUrl: './manage-group.component.html',
    styleUrls: ['./manage-group.component.css']
})
export class ManageGroupComponent implements OnInit, OnDestroy {
    modalRef: BsModalRef;
    @ViewChild('groupDetails') groupDetailsTmplt: TemplateRef<any>;
    @ViewChild('confirmation') confirmationTmplt: TemplateRef<any>;
    @ViewChild('addRegistration') addRegistrationTmplt: TemplateRef<any>;

    nonGroupedEquipment: any[];

    items: TreeNode[];
    selectedItem: TreeNode;

    currentDate: any;
    calendarLocaleSetting: any;

    cols: any[];

    selectedGroup: EquipmentGroup;

    confirmAcceptButton;
    confirmCancelButton;
    confirmMsg: string[];

    addRegistrationData: any = null;

    myDatePickerOptions: INgxMyDpOptions = {};
    @Output() buttonEvent = new EventEmitter<string>();

    dateSubscription: Subscription;

    constructor(
        private modalService: BsModalService,
        private translate: TranslateService,
        private equipmentService: EquipmentService,
        private alertService: AlertService,
        private offerEntryDataService: OfferEntryDataService,
        private messageService: MessageService,
        private utilsService: UtilsService
    ) {
        this.confirmAcceptButton = this.translate.instant('default-text.yes');
        this.confirmCancelButton = this.translate.instant('default-text.no');
    }

    ngOnInit() {
        this.setDateFormatOptions();

        this.cols = [{ field: 'name', header: this.translate.instant('default-text.group') }];
        this.equipmentService.getGroupList().subscribe(data => {
            this.items = data;
        });

        this.equipmentService.getNonGroupedEquipment().subscribe((data) => {
            this.utilsService.debugLog('non-grouped-equipment subscribe', data);
            this.nonGroupedEquipment = data;
        });

        this.subscribeToCurrentDateWS();
    }

    ngOnDestroy() {
        if (this.dateSubscription) {
            this.dateSubscription.unsubscribe();
        }
    }

    subscribeToCurrentDateWS() {
        if (!this.dateSubscription) {
            this.dateSubscription = this.offerEntryDataService.getCurrentDate().subscribe(currentDate => {
                if (currentDate) {
                    this.currentDate = this.getWSDateAsSpecialDate(currentDate);
                }
            });
        }
    }

    getWSDateAsSpecialDate(d: Date) {
        return { date: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() }, };
    }

    setDateFormatOptions() {
        this.myDatePickerOptions = {
            dayLabels: {
                su: this.translate.instant('calendar.day.su'),
                mo: this.translate.instant('calendar.day.mo'),
                tu: this.translate.instant('calendar.day.tu'),
                we: this.translate.instant('calendar.day.we'),
                th: this.translate.instant('calendar.day.th'),
                fr: this.translate.instant('calendar.day.fr'),
                sa: this.translate.instant('calendar.day.sa')
            },
            monthLabels: {
                1: this.translate.instant('calendar.month.1'),
                2: this.translate.instant('calendar.month.2'),
                3: this.translate.instant('calendar.month.3'),
                4: this.translate.instant('calendar.month.4'),
                5: this.translate.instant('calendar.month.5'),
                6: this.translate.instant('calendar.month.6'),
                7: this.translate.instant('calendar.month.7'),
                8: this.translate.instant('calendar.month.8'),
                9: this.translate.instant('calendar.month.9'),
                10: this.translate.instant('calendar.month.10'),
                11: this.translate.instant('calendar.month.11'),
                12: this.translate.instant('calendar.month.12')
            },
            dateFormat: this.translate.instant('calendar.format'),
            todayBtnTxt: this.translate.instant('calendar.today'),
            firstDayOfWeek: this.translate.instant('calendar.first-day-of-week'),
            sunHighlight: true,
            allowSelectionOnlyInCurrentMonth: false
        };
    }

    setGroup(isNew: boolean) {
        this.utilsService.debugLog('setGroup', this.selectedItem);
        this.utilsService.debugLog('currentDate', this.currentDate);
        this.selectedGroup = {};
        if (isNew) {
            this.selectedGroup = {
                portfolioId: this.selectedItem.data.id,
                id: '',
                code: '',
                nameEn: '',
                nameLocal: '',
                startDatetime: this.currentDate,
                endDatetime: null,
                deratingFactor: 1
            };
        } else {
            this.selectedGroup = {
                portfolioId: this.selectedItem.parent.data.id,
                id: this.selectedItem.data.id,
                code: this.selectedItem.data.code,
                nameEn: this.selectedItem.data.nameEn,
                nameLocal: this.selectedItem.data.nameLocal,
                startDatetime: this.getWSDateAsSpecialDate(new Date(this.selectedItem.data.startDatetime)),
                endDatetime: (!this.selectedItem.data.endDatetime) ? null : this.getWSDateAsSpecialDate(new Date(this.selectedItem.data.endDatetime)),
                deratingFactor: this.selectedItem.data.deratingFactor
            };
        }
        this.utilsService.debugLog(this.selectedGroup);
        this.openModal(this.groupDetailsTmplt);
    }

    update(selectedGroup: EquipmentGroup) {
        this.utilsService.debugLog('update group', selectedGroup);
        if (this.selectedGroup.id === '') { // Create Group
            this.equipmentService.createGroup(selectedGroup).subscribe((response) => {
                const msg: MessageData = new MessageData();
                msg.setData('PORTFOLIO', selectedGroup.portfolioId, selectedGroup.code);
                this.messageService.createGroup(msg);
                this.alertService.success('Successfully created the group!');
                this.modalRef.hide();
            }, (error) => {
                this.alertService.error(error);
            });
        } else {    // Update Group
            this.equipmentService.updateGroup(selectedGroup).subscribe((response) => {
                const msg: MessageData = new MessageData();
                msg.setData('PORTFOLIO', selectedGroup.portfolioId, selectedGroup.code);
                this.messageService.updateGroup(msg);
                this.alertService.success('Successfully edited the group!');
                this.modalRef.hide();
            }, (error) => {
                this.alertService.error(error);
            });
        }

        this.modalRef.hide();
    }

    delete(item: TreeNode) {
        if (item.data.aggregationlevel === 'GROUP') {
            const group: EquipmentGroup = {
                portfolioId: item.parent.data.id,
                id: item.data.id,
                code: item.data.code,
                nameEn: item.data.nameEn,
                nameLocal: item.data.nameLocal,
                startDatetime: item.data.startDate,
                endDatetime: item.data.endDate,
                deratingFactor: item.data.deratingFactor
            };
            this.equipmentService.deleteGroup(group).subscribe((response) => {
                const msg: MessageData = new MessageData();
                msg.setData('PORTFOLIO', group.portfolioId, group.code);
                this.messageService.removeGroup(msg);
                this.alertService.success('Successfully deleted the group!');
                this.modalRef.hide();
            }, (error) => {
                this.alertService.error(error);
            });

            this.utilsService.debugLog('delete group', group);
        } else if (item.data.aggregationlevel === 'REGISTRATION') {
            const registration = {
                portfolioId: item.parent.parent.data.id,
                groupId: item.parent.data.id,
                groupCode: item.parent.data.code,
                registrationId: item.data.id,
                registrationName: item.data.name
            };

            this.equipmentService.removeEquipmentFromGroup(
                registration.portfolioId, registration.groupId, registration.registrationId
            ).subscribe((response) => {
                const msg: MessageData = new MessageData();
                msg.setData('GROUP', registration.portfolioId, registration.groupId);
                msg.addDetail(registration.groupCode, 0, registration.registrationId);
                this.messageService.removeRegFromGroup(msg);
                this.alertService.success(
                    this.translate.instant('shared.offer-entry-grid.success-remove-registration') +
                    '(' + registration.registrationId + ') ' + registration.registrationName
                );
                this.modalRef.hide();
            }, (error) => {
                if (error instanceof HttpErrorResponse) {
                    if (error.status === 409) {
                        this.alertService.error(error.error.error_description);
                    }
                }
                this.modalRef.hide();
            });
        }
    }

    addRegistrationClicked(item: TreeNode) {
        this.utilsService.debugLog(this.selectedItem);
        const portfolioId: string = item.parent.data.id;
        if (this.nonGroupedEquipment) {
            const portfolioData = this.nonGroupedEquipment.filter(portfolio => {
                if (portfolio.id === portfolioId) {
                    return true;
                }
            });

            if (portfolioData.length > 0) {
                this.addRegistrationData = {
                    portfolioId: portfolioData[0].id,
                    data: portfolioData[0].equipment,
                    isGroup: false
                };
                this.utilsService.debugLog('addRegistration', this.addRegistrationData);
                this.openModal(this.addRegistrationTmplt);
            }
        }
    }

    receiveAddRegistrationButtonEvent(selectedGroup, $event) {
        if (typeof $event === 'string') {
            if ($event === 'Cancel') {
                // this.utilsService.debugLog('canceled');
            }
        } else {
            this.utilsService.debugLog($event.equipmentList);
            this.equipmentService.addEquipmentToGroup(
                selectedGroup.parent.data.id,
                selectedGroup.data.id,
                $event.equipmentList
            ).subscribe((response) => {
                if (Array.isArray(response) && response.length > 0) {
                    this.utilsService.debugLog('equipment added', response);

                    const successList: string[] = [];
                    const failedList: string[] = [];
                    const success: any[] = [];
                    const fail: any[] = [];
                    for (const res of response) {
                        if (res.success) {
                            success.push(res);
                            successList.push(`[${res.equipmentId}] ${res.equipmentName}`);
                        } else {
                            fail.push(res);
                            failedList.push(`[${res.equipmentId}] ${res.equipmentName} - ${res.response.error.error_description}`);
                        }
                    }

                    let message: string = `${this.translate.instant('default-text.total')}: ${response.length}`;

                    if (success.length > 0) {
                        message += '\n' + this.translate.instant('default-text.success') + ': ' + success.length.toString() + '\n';
                        message += successList.join('\n');

                        this.utilsService.debugLog('groupID:', selectedGroup);
                        const msg: MessageData = new MessageData();
                        msg.setData('GROUP', selectedGroup.parent.data.id, selectedGroup.data.id);
                        for (let i = 0 ; i < success.length ; i++) {
                            msg.addDetail(selectedGroup.data.code, i, success[i].equipmentId);
                        }
                        this.utilsService.debugLog('mssageData', msg);
                        this.messageService.addRegToGroup(msg);
                    }

                    if (fail.length > 0) {
                        message += '\n' + this.translate.instant('default-text.failure') + ': ' + failedList.length.toString() + '\n';
                        message += failedList.join('\n');
                    }

                    alert(message);
                }
            }, (error) => {
                this.utilsService.debugLog('failed to add registration(s).', error);
            });
        }
        this.modalRef.hide();
    }

    cancelClicked() {
        this.buttonEvent.emit('Cancel');
    }

    openModal(template: TemplateRef<any>, classList?: string) {
        const config: ModalOptions = new ModalOptions();
        if (classList) {
            config.class = classList;
        }
        this.modalRef = this.modalService.show(template, config);
    }

    receiveConfirmButtonEvent(event) {
        this.utilsService.debugLog(event);
    }

    openConfirmation(item: TreeNode) {
        this.confirmMsg = [];
        this.confirmMsg.push(this.translate.instant('shared.manage-group.confirmation-delete-item'));
        this.confirmMsg.push('[' + item.data.aggregationlevel + ': ' + item.data.id + ' - ' + item.data.name + ']');
        this.openModal(this.confirmationTmplt);
    }

    confirm(item: TreeNode) {
        this.delete(item);
    }

    getHierarchyLevelFormat(item: TreeNode): string {
        return this.makeHierarchyLevelName(item);
    }

    makeHierarchyLevelName(item: TreeNode): string {
        let returnName: string = '';
        if (item.parent) {
            returnName = this.makeHierarchyLevelName(item.parent);
        }
        return returnName + item.data.name;
    }

    rowTrackBy(index: number, row: any) {
        return row.id;
    }
}





// WEBPACK FOOTER //
// ./src/app/shared/components/manage-group/manage-group.component.ts